import { useLocation, useParams } from 'react-router-dom';
import useListAdminOrganizations from '@/hooks/admin/organizations/useListAdminOrganizations';
import getOrganizationDetailTabPath from '@/pages/admin/organizations/OrganizationDetail/helpers/getOrganizationDetailTabPath';
import isOrganizationInstancePage from '@/pages/admin/organizations/OrganizationDetail/helpers/isOrganizationInstancePage';
import EntityBreadcrumb from '../EntityBreadcrumb';
import resolveOrganizationBreadcrumbLabel from './helpers/resolveOrganizationBreadcrumbLabel';
import type { OrganizationDetailCrumbProps } from './types';

const OrganizationDetailCrumb = ({
    param,
    isCurrentPage = false,
}: OrganizationDetailCrumbProps) => {
    const params = useParams();
    const location = useLocation();
    const organizationId = params[param] || '';
    const { organizations, isLoadingOrganizations } = useListAdminOrganizations();
    const isInstancePage = isOrganizationInstancePage({ pathname: location.pathname });

    const label = resolveOrganizationBreadcrumbLabel({
        organizationId,
        organizations,
        isLoadingOrganizations,
    });

    return (
        <EntityBreadcrumb
            label={label}
            entityId={organizationId}
            entityType="Organization"
            href={getOrganizationDetailTabPath({
                organizationId,
                tab: 'services',
                search: '',
            })}
            isCurrentPage={isCurrentPage && !isInstancePage}
            isLoading={isLoadingOrganizations && label === '...'}
        />
    );
};

export default OrganizationDetailCrumb;
